// *******************************************************************************
// 1.0 - Tinymce Editor
// *******************************************************************************

const tinymceElem = document.querySelectorAll('.tinymce-editor-input');

if (tinymceElem.length) {
  tinymceElem.forEach((el) => {
    tinymce.init({
      autosave_ask_before_unload: false,
      selector: `#${el.getAttribute('id')}`,
      plugins: 'preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker editimage help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons advtable export footnotes mergetags autocorrect',
      menubar: '',
      quickbars_insert_toolbar: 'quicktable',
      toolbar: 'formatselect | undo redo | bold italic underline strikethrough | image fontfamily fontsize blocks | numlist bullist | blockquote | alignleft aligncenter alignright alignjustify | outdent indent | forecolor backcolor removeformat | pagebreak | charmap | fullscreen preview save print | media template link anchor codesample | ltr rtl',
      images_file_types: 'jpg,jpeg,png,gif,svg,webp,bmp',
      file_picker_callback(cb) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', '.png,.gif,.bmp,.jpeg,.jpg,.webp');
        input.onchange = function () {
          const file = this.files[0];
          if (file.size > 3097152) {
            // eslint-disable-next-line no-alert
            alert("The file size exceeds the limit! Please upload a file of 3MB or less");
            return;
          }

          const reader = new FileReader();
          reader.onload = function () {
            cb(reader.result, { title: file.name });
          };
          reader.readAsDataURL(file);
        };
        input.click();
      }
    });
  });
}
